// @ts-nocheck 判断时候是支付宝小程序环境 （ my.isFRM == true smallfish H5+ ）
import { globalWindow } from "./global"; // 判断时候是支付宝小程序环境

export var isMiniAli = // @ts-ignore
typeof my !== 'undefined' && !!my && typeof my.showToast === 'function' && my.isFRM !== true;
var screenWidth;
var screenHeight;
var windowWidth;
var windowHeight;

if (isMiniAli) {
  var myOptions = my.getSystemInfoSync();
  screenWidth = myOptions.screenWidth;
  screenHeight = myOptions.screenHeight;
  windowWidth = myOptions.windowWidth;
  windowHeight = myOptions.windowHeight;
} else {
  var innerWidth = globalWindow.innerWidth,
      innerHeight = globalWindow.innerHeight;
  screenWidth = innerWidth;
  screenHeight = innerHeight;
  windowWidth = innerWidth;
  windowHeight = innerHeight;
}

export var screen = {
  width: screenWidth,
  height: screenHeight,
  availWidth: windowWidth,
  availHeight: windowHeight,
  availLeft: 0,
  availTop: 0
};